import { BaseService } from './base-service';
export class ClassificationService {
    // classification: BehaviorSubject<IClfValue> = new BehaviorSubject<IClfValue>(null);
    // schemas: BehaviorSubject<IClfSchema[]> = new BehaviorSubject<IClfSchema[]>([]);
    // // Share classification data between routes
    // public selectClassification(classification: IClfValue) {
    //   this.classification.next(classification);
    // }
    // ----------------------------------------------------------------------
    // Classifications
    // ----------------------------------------------------------------------
    static getSchemas() {
        return BaseService.get(`classifications/schemas`);
    }
    static getValues(schema) {
        return BaseService.get(`classifications/values/${schema}`);
        // .pipe(tap(data => data.payload.forEach(v => GenericHelper.parseStandardDates(v)))).toPromise();
    }
    static saveValue(item) {
        //this.clfStore.flush();
        return BaseService.save(`classifications/values`, item);
        // .pipe(tap(data => GenericHelper.parseStandardDates(data.payload))).toPromise();
    }
    static deleteValue(oid) {
        // this.clfStore.flush();
        // return BaseService.delete<IClfValue>(`fe/classifications/values/${oid}`).toPromise();
        return BaseService.delete(`classifications/values/${oid}`);
    }
    static searchValueCombo(schema, selfId, search) {
        let qs = encodeURIComponent(search);
        return BaseService.get(`classifications/search-values/${schema}/${selfId}?search=${qs}`);
    }
}
